import sdl from '@jds/react-generated-sdl/JDSMobileBottomSheet';
import type { JDSMobileBottomSheetProps } from './interface';

import { componentsMap } from '../../../generators/componentMap';
import {
  createComponent,
  getCustomJSON,
  useTokenValues
} from '@jds/react-engine';

import { withLogic, BottomSheetProps } from '../logic';

const Component = (props: BottomSheetProps) => {
  const { platform } = useTokenValues();

  const json = sdl;
  const {
    kind = 'overlay',
    controlType = 'normal',
    isCustom = false,
    close = true,
    primaryCtaDisabled = false,
    secondaryCtaDisabled = false,
    custom = '',
    ...rest
  } = props as any;
  return createComponent(
    json,
    {
      kind,
      controlType,
      isCustom,
      close,
      primaryCtaDisabled,
      secondaryCtaDisabled,
      ...rest
    },
    'JDSMobileBottomSheet',
    componentsMap,
    getCustomJSON(custom || '') || {}
  );
};

const BottomSheet = withLogic(Component) as React.FC<BottomSheetProps> & {
  slotName?: string;
};

BottomSheet.displayName = 'BottomSheet';
BottomSheet.slotName = 'jds_mobile_bottom_sheet';

export { BottomSheet, type JDSMobileBottomSheetProps };
